import {Autocomplete} from "@mui/material";
import {TextField} from "@variocube/app-ui";
import React, {useMemo} from "react";
import {useLocalization} from "../i18n";
import {useCreditorApi} from "../api";
import {useAsync} from "react-async-hook";

interface CreditorSelectProps {
	label?: string;
	required?: boolean;
	value: number | undefined;
	onChange: (value: number | undefined) => void;
	fullWidth?: boolean;
	disabled?: boolean;
	creditCardProvider?: boolean;
}

export function CreditorSelect(props: Readonly<CreditorSelectProps>) {
	const {label, required, value, onChange, fullWidth, disabled, creditCardProvider} = props;
	const {t} = useLocalization();

	const {queryCreditors} = useCreditorApi();
	const query = useMemo(() => ({
		creditCardProvider
	}), [creditCardProvider]);
	const {loading, result} = useAsync(queryCreditors, [query]);

	const creditors = result?.content ?? [];

	return (
		<Autocomplete
			renderInput={(parameters) => (
				<TextField placeholder={t("hint.select")} required={required} label={label} {...parameters} />
			)}
			fullWidth={fullWidth}
			disabled={disabled}
			loading={loading}
			options={creditors ?? []}
			getOptionLabel={creditor => creditor.company.companyName ?? ""}
			value={creditors?.find(creditor => creditor.id == value) ?? null}
			getOptionKey={inbox => inbox.id}
			onChange={(_, v) => {
				onChange(v?.id ?? undefined);
			}}
			autoSelect
			autoHighlight
		/>
	);
}
